import { render } from "./ModalValidatePaymentMethodList.vue?vue&type=template&id=1c6a88e2&scoped=true&ts=true"
import script from "./ModalValidatePaymentMethodList.vue?vue&type=script&lang=ts"
export * from "./ModalValidatePaymentMethodList.vue?vue&type=script&lang=ts"

import "./ModalValidatePaymentMethodList.vue?vue&type=style&index=0&id=1c6a88e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6a88e2"]])

export default __exports__